import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { DeleteAssessmentBase } from "../DeleteAssessmentBase";

/**
 * Delete an actual assessment.
 */
export const DeleteAssessment = () => (<DeleteAssessmentBase defaultAssessmentType={AssessmentType.Assessment} />);
